/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryList(_, data) {
      return await api.post(`/api/article/reportLists`, data);
    },
  },
}
